import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const planevaActividadesExtras = `${baseUrl}/planeva-actividades-extras`;

export const allActividadesExtrasService = async (params) => {
  const res = await axios.get(planevaActividadesExtras, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveActividadesExtrasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${planevaActividadesExtras}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(planevaActividadesExtras, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneActividadesExtrasService = async (id) => {
  const res = await axios.get(`${planevaActividadesExtras}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteActividadesExtrasService = async (id) => {
  const res = await axios.delete(`${planevaActividadesExtras}/${id}`, {
    headers: token({}),
  });
  return res;
};
